import { factory } from "../../../../utils/apiThunkFactory";

export const updateConference = factory.put("myEventModal/createConference", "/api/bookings/update/:ConferenceId");
export const fetchExternalParticipants = factory.get("fetchExternalParticipants", "/api/bookings/get-external-participants/:ConferenceId");
export const updateMapAccess = factory.post("updateMapAccess", "/api/bookings/update-map-access");
export const updateParticipantStatus = factory.post("updateParticipantStatus", "/api/bookings/update-participant-status");
export const sendRemeinder = factory.post("sendRemeinder", "/api/bookings/send-remeinder");
export const getConferenceLogs = factory.get("logsConference", "/api/conferenceAction/get/:id");
export const stopConference = factory.post("stopConference", "/api/bookings/stop-conference");


